import { useQuery } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { SCHOOL_INVENTORY_DETAIL_BY_SCHOOL_ID } from "../apiRoutes";

// src/types/SchoolInventoryDetailApi.ts

export interface SchoolInventoryDetailApi {
  _id: string;
  schoolId: string;

  // ✅ Include all boolean inventory fields
  isTvIncluded: boolean;
  is3DPrinterIncluded: boolean;
  isPaintingIncluded: boolean;
  isElectricalIncluded: boolean;
  isStorageCabinetsIncluded: boolean;
  isTeachersTableIncluded: boolean;
  isPodiumIncluded: boolean;
  isTabletsIncluded: boolean;
  isChairsIncluded: boolean;

  // ✅ Notes
  infrastructureNotes?: string | null;
  curriculumNotes?: string | null;
  otherNotes?: string | null;

  // ✅ Common metadata
  createdBy?: string;
  lastUpdatedBy?: string;
  createdAt?: string;
  updatedAt?: string;
}


export interface SchoolInventoryDetailResponse {
  data?: SchoolInventoryDetailApi | null;
}

export const useGetSchoolInventoryDetailBySchoolIdQuery = (
  schoolId: string,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: ["schoolInventoryBasicDetail", schoolId], // ✅ Unique key
    enabled: Boolean(schoolId) && (options?.enabled ?? true),
    queryFn: async () => {
      const res = await axiosAuth.get<SchoolInventoryDetailResponse>(
        `${SCHOOL_INVENTORY_DETAIL_BY_SCHOOL_ID}${schoolId}/`
      );
      return res.data;
    },
  });
};


